import { routes } from '@pmai/contracts';
import { Alert, Spinner } from '@pmai/ui';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiMutation } from '../../shared/api/hooks';
import { useErrorText } from '../../shared/i18n';
import { AuthCard, BackToLogin, useTokenParam } from './auth-layout';

/** FR-AUTH-102: the link from the e-mail confirms the address once. */
export function VerifyEmailPage() {
  const { t } = useTranslation();
  const errorText = useErrorText();
  const token = useTokenParam();
  const verify = useApiMutation(routes.auth.verifyEmail);
  const sent = useRef(false);

  useEffect(() => {
    if (token && !sent.current) {
      sent.current = true; // StrictMode runs effects twice; a token works only once
      verify.mutate({ body: { token } });
    }
  }, [token, verify]);

  return (
    <AuthCard title={t('auth.verify.title')} footer={<BackToLogin />}>
      {!token ? (
        <Alert tone="danger">{t('auth.missingToken')}</Alert>
      ) : verify.isError ? (
        <Alert tone="danger">{errorText(verify.error)}</Alert>
      ) : verify.isSuccess ? (
        <Alert tone="success">{t('auth.verify.done')}</Alert>
      ) : (
        <Spinner label={t('auth.verify.pending')} />
      )}
    </AuthCard>
  );
}
